import { observable, computed, action } from "mobx";
import { tl } from "../../../../../utils";

const fsTabsData = {
  static: {
    title: tl("Загруженные файлы курса"),
    titleMobile: tl("Мои файлы"),
    notinlessons: {
      title: tl("Неиспользуемые в уроках")
    },
    lessons: {
      title: tl("Файлы по урокам")
    },
    homeworks: {
      title: tl("Файлы домашних заданий"),
      titleMobile: tl("Файлы ДЗ"),
      tabs: [
        {
          section: "homeworks",
          tab: "all",
          label: tl("Все файлы в ДЗ"),
          labelMobile: tl("Все файлы")
        },
        {
          section: "homeworks",
          tab: "students",
          label: tl("Файлы по ученикам"),
          labelMobile: tl("По ученикам")
        },
        {
          section: "homeworks",
          tab: "curators",
          label: tl("Файлы автора и наставников"),
          labelMobile: tl("Автора и наставников")
        }
      ]
    },
    chats: {
      title: tl("Файлы чатов"),
      tabs: [
        {
          section: "chats",
          tab: "all",
          label: tl("Все файлы в чатах"),
          labelMobile: tl("Все файлы")
        },
        {
          section: "chats",
          tab: "private",
          label: tl("Личные чаты")
        },
        {
          section: "chats",
          tab: "group",
          label: tl("Групповые чаты")
        }
      ]
    },
    default: {
      tabs: [
        {
          section: "notuse",
          tab: "all",
          label: tl("Загруженные файлы"),
          labelMobile: tl("Все файлы")
        },
        {
          section: "lessons",
          label: tl("Файлы в уроках"),
          labelMobile: tl("В уроках")
        },
        {
          section: "notuse",
          tab: "notinlessons",
          label: tl("Неиспользуемые в уроках"),
          labelMobile: tl("Без уроков")
        }
      ]
    }
  },
  widget: {
    title: tl("Прикрепление файлов"),
    titleMobile: tl("Файлы"),
    titleOfType: {
      all: tl("Прикрепление файлов"),
      video: tl("Прикрепление видео"),
      transcription: tl("Выбор видео для транскрибации"),
      audio: tl("Прикрепление аудио"),
      image: tl("Прикрепление изображений")
    },
    titleOfTypeMobile: {
      all: tl("Файлы"),
      video: tl("Видео"),
      audio: tl("Аудио"),
      image: tl("Изображения")
    },
    tabs: [
      {
        section: "notuse",
        tab: "all",
        labelOfType: {
          all: tl("Все файлы"),
          video: tl("Все видео"),
          transcription: tl("Все видео"),
          audio: tl("Все аудио"),
          image: tl("Все изображения")
        },
        label: tl("Все файлы"),
        labelMobile: tl("Все файлы")
      },
      {
        section: "lessons",
        label: tl("По урокам"),
        labelMobile: tl("В уроках")
      },
      {
        section: "notuse",
        tab: "notinlessons",
        label: tl("Неиспользуемые в уроках"),
        labelMobile: tl("Без уроков")
      }
    ],
    tabsTranscription: [
      {
        section: "notuse",
        tab: "all",
        labelOfType: {
          all: tl("Все файлы"),
          video: tl("Все видео"),
          transcription: tl("Все видео"),
          audio: tl("Все аудио"),
          image: tl("Все изображения")
        },
        label: tl("Все файлы"),
        labelMobile: tl("Все файлы")
      },
      {
        section: "notuse",
        tab: "notinlessons",
        label: tl("Неиспользуемые в уроках"),
        labelMobile: tl("Без уроков")
      }
    ],
    homeworks: {
      tabs: [
        {
          section: "homeworks",
          tab: "all",
          label: tl("Файлы ДЗ")
        }
      ]
    },
    chats: {
      tabs: [
        {
          section: "chats",
          tab: "all",
          label: tl("Файлы чатов")
        }
      ]
    }
  }
};

export default class FSTabsStore {
  rootStore: any;
  data: any;
  constructor(RootStore: any) {
    this.rootStore = RootStore;
  }

  @computed get getFSTitle() {
    this.data = this.rootStore.fsStore.isWidget
      ? fsTabsData.widget
      : fsTabsData.static;

    if (
      this.rootStore.fsCourseStore.filesSection === "notuse" &&
      this.rootStore.fsCourseStore.filesSectionTab === "notinlessons"
    ) {
      if (this.data.notinlessons) {
        return this.data.notinlessons.title;
      }
    }
    // Заголовок по текущей секции и типу файлов
    return this.data[this.rootStore.fsCourseStore.filesSection] &&
      this.data[this.rootStore.fsCourseStore.filesSection].titleOfType &&
      this.data[this.rootStore.fsCourseStore.filesSection].titleOfType[
        this.rootStore.fsCourseStore.filterFilesType
      ]
      ? this.data[this.rootStore.fsCourseStore.filesSection].titleOfType[
          this.rootStore.fsCourseStore.filterFilesType
        ]
      : // Заголовок по текущей секции
      this.data[this.rootStore.fsCourseStore.filesSection] &&
        this.data[this.rootStore.fsCourseStore.filesSection].title
      ? this.data[this.rootStore.fsCourseStore.filesSection].title
      : // Заголовок по типу файлов
      this.data.titleOfType &&
        this.data.titleOfType[this.rootStore.fsCourseStore.filterFilesType]
      ? this.data.titleOfType[this.rootStore.fsCourseStore.filterFilesType]
      : // Заголовок
        this.data.title;
  }

  @computed get getFSTitleMobile() {
    this.data = this.rootStore.fsStore.isWidget
      ? fsTabsData.widget
      : fsTabsData.static;

    if (
      this.rootStore.fsCourseStore.filesSection === "notuse" &&
      this.rootStore.fsStore.filesSectionTab === "notinlessons"
    ) {
      return this.data.notinlessons.titleMobile
        ? this.data.notinlessons.titleMobile
        : this.getFSTitle;
    }
    // Моб. заголовок по текущей секции и типу файлов
    return this.data[this.rootStore.fsCourseStore.filesSection] &&
      this.data[this.rootStore.fsCourseStore.filesSection].titleOfTypeMobile &&
      this.data[this.rootStore.fsCourseStore.filesSection].titleOfTypeMobile[
        this.rootStore.fsCourseStore.filterFilesType
      ]
      ? this.data[this.rootStore.fsCourseStore.filesSection].titleOfTypeMobile[
          this.rootStore.fsCourseStore.filterFilesType
        ]
      : // Моб. заголовок по текущей секции
      this.data[this.rootStore.fsCourseStore.filesSection] &&
        this.data[this.rootStore.fsCourseStore.filesSection].titleMobile
      ? this.data[this.rootStore.fsCourseStore.filesSection].titleMobile
      : // Моб. заголовок по типу файлов
      this.data.titleOfTypeMobile &&
        this.data.titleOfTypeMobile[
          this.rootStore.fsCourseStore.filterFilesType
        ]
      ? this.data.titleOfTypeMobile[
          this.rootStore.fsCourseStore.filterFilesType
        ]
      : // Моб. заголовок
      this.data.titleMobile
      ? this.data.titleMobile
      : // ПК заголовок
        this.getFSTitle;
  }

  @computed get getFSTabs() {
    this.data = this.rootStore.fsStore.isWidget
      ? fsTabsData.widget
      : fsTabsData.static;

    // Получение списка вкладок для текущей секции
    const isTranscription = this.rootStore.fsCourseStore.filterFilesType === 'transcription';
    const fsTabsAll = (isTranscription ? this.data.tabsTranscription : this.data.tabs) ?? [];
    const currentSection =
      this.rootStore.fsCourseStore.filesSectionInitial &&
      this.rootStore.fsStore.isWidget
        ? this.rootStore.fsCourseStore.filesSectionInitial
        : this.rootStore.fsCourseStore.filesSection;
    const fsTabsModule =
      this.data[currentSection] && this.data[currentSection].tabs
        ? this.data[currentSection].tabs
        : this.data.default && this.data.default.tabs
        ? this.data.default.tabs
        : [];
    return [...fsTabsAll, ...fsTabsModule];
  }
}
